import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center text-center px-4 py-24 md:py-32 min-h-[60vh]">
      <h1 className="absolute bottom-4 text-8xl md:text-[10rem] font-heading font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mx-auto">
          <i className="ri-compass-3-line w-7 h-7 flex items-center justify-center text-3xl" />
        </span>
        <h2 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          页面走丢了
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto">
          你访问的页面不存在或已被移除。当前路径：<span className="text-foreground-800">{location.pathname}</span>
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-700 text-background-50 text-sm hover:bg-primary-800 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-5-line w-4 h-4 flex items-center justify-center" />
            返回首页
          </Link>
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center" />
            浏览赛事分类
          </Link>
        </div>
      </div>
    </div>
  );
}